import { useQuery } from '@tanstack/react-query'
import {
  VerifiedTokenListResponse,
  VerifiedToken,
} from 'pages/api/verifiedTokens'
import { toContextTuplesString } from 'utils/logging'

async function fetchVerifiedTokenList(): Promise<VerifiedToken[]> {
  try {
    const response = await fetch('/api/verifiedTokens')
    if (!response.ok) {
      console.error(
        `failed to fetch verified token list: ${toContextTuplesString({
          status: response.status,
          body: await response.text(),
        })}`,
      )
      return []
    }

    let responseData: VerifiedTokenListResponse
    try {
      responseData = (await response.json()) as VerifiedTokenListResponse
    } catch (e) {
      console.error('error parsing verified token list response', e)
      return []
    }

    return !('error' in responseData) ? responseData.data : []
  } catch (e) {
    console.error('failed to fetch verified token list', e)
    return []
  }
}

export const useVerifiedTokenList = () => {
  const { data: verifiedTokenList } = useQuery({
    queryKey: ['verified-token-list'],
    queryFn: () => fetchVerifiedTokenList(),
    retry: 1,
    refetchOnWindowFocus: false,
    enabled: true,
  })

  return { verifiedTokenList }
}
